import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { push } from "store/actions/router";
import { FiCode } from "react-icons/fi";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import type { RootState } from "types/state";
import {
  hasAddedGroups,
  hasAnnouncedIcon,
  hasAddedDeductionCode,
  hasLaunchedPlan,
} from "store/selectors/employer";

import Accordian from "./Accordian";

const mapStateToProps = (state: RootState) => {
  const { user } = state;
  return {
    user,
    hasAddedGroups: hasAddedGroups(state),
    hasAddedDeductionCode: hasAddedDeductionCode(state),
    hasAnnouncedIcon: hasAnnouncedIcon(state),
    hasLaunchedPlan: hasLaunchedPlan(state),
  };
};

const mapDispatchToProps = {
  push,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface OwnProps {
  activeStepNumber?: number;
  showDeductionCode?: (...args: unknown[]) => void;
  showDeductionCodeFinal?: (...args: unknown[]) => void;
  hasInvitedEmployees?: boolean;
}

type Props = WithApolloClient<OwnProps & PropsFromRedux>;

class AddDeductionCodeCard extends React.PureComponent<Props> {
  render() {
    let activeStepNumber = 1;

    let onClick = this.props.showDeductionCode;

    const steps = [{ index: 1, label: "Add a deduction code" }];

    return (
      <Accordian
        onClick={onClick}
        icon={<FiCode color="white" stroke="#60A4BF" size={16} />}
        title={"Payroll Deduction Setup"}
        description={
          "Add a generic after-tax deduction for an exact dollar amount, named Icon."
        }
        actionText={"Setup Deduction"}
        disabled={!this.props.hasAddedGroups}
        completedAction={this.props.hasAddedDeductionCode}
        activeStepNumber={activeStepNumber}
        steps={steps}
      />
    );
  }
}

export default connector(withApollo<Props>(AddDeductionCodeCard));
